import { cleanFilters, privateClient, SelectedFilters } from '@lidea/shared/data-access/core';
import { Heatmap } from '@lidea/shared/util/types';

export type BulkHeatmapsResponse = {
  plots: Record<string, Record<string, Heatmap[]>>;
};

export const offlineSyncApi = {
  getBulkHeatmaps: (params: {
    plotIds: number[];
    types: string[];
    filters: SelectedFilters;
  }) => {
    const cleanedFilters = cleanFilters(params.filters);
    return privateClient
      .get('offline-sync/heatmaps/', {
        searchParams: {
          ...cleanedFilters,
          plot_ids: params.plotIds.join(','),
          types: params.types.join(','),
        },
      })
      .json<BulkHeatmapsResponse>();
  },
};
